import {userConstants} from '../constants'
import {anonAPI} from '../services/api'

export function loginAction (email, password, onError) {
  return dispatch => {
    dispatch(request({email}))  // could be removed
    anonAPI.post('auth/local', {email, password})
      .then((response) => {
        const {data} = response
        dispatch(success(data.token))
      })
      .catch(error => {
        onError(error)
        dispatch(failure(error))
      })
  }

  function request (user) {
    return {type: userConstants.LOGIN_REQUEST, user}
  }

  function success (token) {
    return {type: userConstants.LOGIN_SUCCESS, token}
  }

  function failure (error) {
    return {type: userConstants.LOGIN_FAILURE, error}
  }
}



// WEBPACK FOOTER //
// ./src/actions/authentication.actions.js